import React, { useMemo } from 'react';
import { DataTable } from '@/components';
import { userManagementTableColumns } from './UserManagementDataTableConfig';
import { 
  IUserManagementListResponse,
  IUserManagementTableRow,
} from '@/types/admin/userManagement';
import { IDataTableResponse } from '@/types/admin/dataTable';

interface UserManagementDataTableProps {
  data: IUserManagementListResponse;
  tableRows: IUserManagementTableRow[];
  totalFilteredCount: number;
  isLoading: boolean;
  onUserSelect?: (user: IUserManagementTableRow) => void;
  updateCsvData?: (data: IUserManagementTableRow[]) => void;
  showSearch?: boolean;
}

export const UserManagementDataTable: React.FC<UserManagementDataTableProps> = ({
  data,
  tableRows,
  totalFilteredCount,
  isLoading,
  onUserSelect,
  updateCsvData,
  showSearch = false,
}) => {


  // Transform data to match generic DataTable interface
  const tableData: IDataTableResponse<IUserManagementTableRow> = useMemo(() => ({
    rows: tableRows,
    count: totalFilteredCount, // Use filtered count for proper pagination display
  }), [tableRows, totalFilteredCount]);
  // Production: avoid noisy logs

  const handleRowSelect = (user: IUserManagementTableRow, index: number) => {
    onUserSelect?.(user);
  };

  return (
    <DataTable
      data={tableData}
      columns={userManagementTableColumns}
      isLoading={isLoading}
      searchPlaceholder="Search users by name or email..."
      onRowSelect={handleRowSelect}
      updateCsvData={updateCsvData}
      emptyStateType="userManagement"
      mobileColumnCount={2}
      showSearch={showSearch}
      showSort={true}
      showFilter={true}
    />
  );
};
